import React, { useCallback } from 'react';
import { EButtonType, TButton } from './button.types';
import { ButtonStyles } from './button.styles';
import { Preloader } from './components/preloader';

const Button: React.FC<TButton> = ({
    children,
    styleType = EButtonType.Primary,
    color = 'primary',
    ...rest
}) => {
    const handleOnClick = useCallback(() => {
        if (!rest?.disabled && !rest.isLoading) rest?.onClick && rest.onClick();
    }, [rest]);

    return (
        <ButtonStyles
            styleType={styleType}
            color={color}
            {...rest}
            onClick={handleOnClick}
        >
            {!rest?.disabled && rest?.isLoading ? (
                <Preloader styleType={styleType} />
            ) : (
                children
            )}
        </ButtonStyles>
    );
};

export default Button;
